import { Component, ViewChild, ElementRef } from "@angular/core";
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { StaticConstantsProvider } from "../../providers/static-constants/static-constants";
import { TranslateService } from '@ngx-translate/core';
import { Chart } from 'chart.js';
import * as moment from "moment";

@Component({
  selector: 'page-modal',
  templateUrl: 'modal.html',
})


export class ModalPage {

  @ViewChild("chartCanvas") chartCanvas: ElementRef;

  public lineChart: Chart;
  currentvar: String
  currentvarTranslated: String
  currentlatlon: String
  currentvalue: number
  currentUM: String
  startDateS0: String
  endDateS0: String
  startDateS1: String
  endDateS1: String

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public translate: TranslateService,
    public consts: StaticConstantsProvider
  ) {

  }



  closeModal() {
    this.navCtrl.first().dismiss();
  }

  /** ****************************************************
  * 
  * Charts
  * 
  ******************************************************* */
  ngOnInit() {
    let data = this.navParams.get('data')
    let variable = this.navParams.get('var')
    let LatLng = this.navParams.get('LatLng')
    let currentDateTimeString = this.navParams.get('currentDateTimeString')
    // console.log("ngOnInit", data)
    // console.log("variable", variable)
    // console.log("LatLng", LatLng)

    this.currentlatlon = LatLng;
    this.currentvar = variable.name;
    this.translate.get(variable.name).subscribe((text: string) => {
      this.currentvarTranslated = text.replace(/-/g, " ") 
    });

    var tmpVar = variable.title;
    tmpVar = tmpVar.replace("TORRE-GUACETO:", "")
    tmpVar = tmpVar.replace("ARPA-FVG:", "")

    switch (tmpVar) {

      case 'Sea-Temperature':
        this.currentUM = '°C'
        break
      case 'Temperature':
        this.currentUM = '°C'
        break
      case 'Salinity':
        this.currentUM = 'psu'
        break
      case 'Sea-Surface-Height':
        this.currentUM = 'm'
        break
      case 'Currents':
        this.currentUM = 'm/s'
        break
      case 'Mixed-Layer':
        this.currentUM = 'm'
        break
      case 'Turbidity':
        this.currentUM = 'mg/l'
        break
      case 'Oxygen-Concentration':
        this.currentUM = 'mg/l'
        break
      case 'MEDSEA_20000101_20000101_0000_0_Total-Sea-Level':
        this.currentUM = 'm'
        break
      default:
        this.currentUM = ''
    }
    if (variable.title === 'MEDSEA_20000101_20000101_0000_0_Total-Sea-Level') {
      if(variable.name =="MEDSEA_Relative-Sea-Level")
        this.plotTwoDataset(data,this.currentUM,2);
      else
        this.plotTwoDataset(data,this.currentUM,1);
    } else if (variable.title.includes("TORRE-GUACETO") || variable.title.includes("ARPA-FVG")) {
      this.plotTwoDataset(data,this.currentUM,1);
    }
    else this.plotOneDataset(data,this.currentUM, currentDateTimeString)

  }


  /** ****************************************************
  * 
  * 
  * 
  ******************************************************* */
  plotOneDataset(data: any[],UM:any, currentDateTimeString: String) {
    let xDataS0 = []
    let yDataS0 = []
    // Main dataset
    data.forEach(element => {
      
      //"merchant_id" in thisSession
      if (element.hasOwnProperty('properties')){
        
        yDataS0.push(parseFloat(element.properties.value).toFixed(3))  //(element.value)
        //m.format('ddd, D MMM')
        xDataS0.push(moment(element.properties.time).utc().format('ddd, D MMM HH:mm'));
        //replace(":00+00:00", ""))
        //console.log(element);

        if (element.properties.time === currentDateTimeString) {
          this.currentvalue = Number(parseFloat(element.properties.value).toFixed(2))// Math.round(element.value * 100) / 100
        }
    }
    });

    this.startDateS0 = xDataS0[0]
    this.endDateS0 = xDataS0[xDataS0.length - 1]
    
    this.lineChart = new Chart(this.chartCanvas.nativeElement, {
      type: "line",
      data: {
        labels: xDataS0,
        datasets: [
          {
            label: this.currentvar,
            fill: false,
            lineTension: 0.1,
            backgroundColor: "#4b7ac0",
            borderWidth: 2,
            borderColor: "#4b7ac0",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            // pointStyle: 'line',
            pointBorderColor: "#4b7ac0",
            pointBackgroundColor: "#4b7ac0",
            pointBorderWidth: 0.5,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "#4b7ac0",
            pointHoverBorderColor: "#4b7ac0",
            pointHoverBorderWidth: 1,
            pointRadius: 0.5,
            pointHitRadius: 10,
            data: yDataS0,
            spanGaps: false
          }
        ]
      },
      options: {
        responsive: true,
        scales: {
          xAxes: [{
            // type: "time",
            // time: {
            //   unit: 'hour',
            //   unitStepSize: 0.5,
            //   round: 'hour',
            //   tooltipFormat: "h:mm:ss a",
            //   displayFormats: {
            //     hour: 'MMM D, h:mm A'
            //   }
            // }
          }],
      
          yAxes: [
            {
              ticks: {
                beginAtZero: false
              },
              scaleLabel: {
                display: true,
                labelString: this.currentvarTranslated+' ['+this.currentUM+']'
              }
            }
          ]
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';
                  if (label) label += ': ';
                  label += tooltipItem.yLabel + ' ' + UM;
                  return label;
                }
            }
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            fontColor: '#333',
            useLineStyle: true,
            // usePointStyle: true,
            // pointStyle: 'line' ,
            // boxWidth: 10,
            // lineWidth: 1,
            // usePointStyle: false,
            // pointStyle: 'border:1px red solid'
          }
        }
      }
    });

  }


  /** ****************************************************
  * 
  * 
  * 
  ******************************************************* */
  plotTwoDataset(data: any[],UM:any, numOfDatasets: number) {


    let xDataS0 = []
    let yDataS0 = []
    let xDataS1 = []
    let yDataS1 = []

    let hideModel = false;
    //let pointRadiusObs = 1.5;
    let borderWidth = 0.5;
    // For in-situ-data
    if(numOfDatasets == 1){
      hideModel = true;
      //pointRadiusObs = 0;
      borderWidth = 2;
    }
      
    // Main dataset -- model
    data[0].forEach(element => {
      yDataS0.push(parseFloat(element.value).toFixed(3))
      xDataS0.push(element.date)
      // if (element.currentLayer === 1) {
      //   this.currentvalue = Math.round(element.value * 100) / 100
      // }
    });
    // Secondary dataset -- observation
    data[1].forEach(element => {
      yDataS1.push(parseFloat(element.value).toFixed(3))  //(element.value)
      xDataS1.push(element.date)
      // if (element.currentLayer === 1) {
      //   this.currentvalue = Math.round(element.value * 100) / 100
      // }
    });
    
    this.startDateS0 = xDataS0[0]
    this.endDateS0 = xDataS0[xDataS0.length - 1]
    this.startDateS1 = xDataS1[0]
    this.endDateS1 = xDataS1[xDataS1.length - 1]

    this.lineChart = new Chart(this.chartCanvas.nativeElement, {
      type: "line",
      data: {
        labels: xDataS0,
        datasets: [
          {
            label: "Observation",
            data: yDataS1,
            fill: false,
            showLine: hideModel,
            lineTension: 0.1,
            borderWidth: borderWidth,
            borderColor: "#d84400",
            pointRadius: 1.5,
            pointBackgroundColor: '#d84400',
            pointBorderColor: "#802800",
          },
          {
            label: "Model",
            data: yDataS0,
            fill: false,
            lineTension: 0.1,
            backgroundColor: "#4b7ac0",
            borderWidth: 2,
            borderColor: "#4b7ac0",
            borderCapStyle: "butt",
            borderDash: [],
            borderDashOffset: 0.0,
            borderJoinStyle: "miter",
            // pointStyle: 'line',
            pointBorderColor: "#4b7ac0",
            pointBackgroundColor: "#4b7ac0",
            pointBorderWidth: 0.5,
            pointHoverRadius: 5,
            pointHoverBackgroundColor: "#4b7ac0",
            pointHoverBorderColor: "#4b7ac0",
            pointHoverBorderWidth: 1,
            pointRadius: 0,
            pointHitRadius: 10,
            spanGaps: false, 
            hidden: hideModel
          }
        ]
      },
      options: {
        responsive: true,
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: false
              },
              scaleLabel: {
                display: true,
                labelString: this.currentvarTranslated+' ['+this.currentUM+']',
              }
            }
          ]
        },
        tooltips: {
            callbacks: {
                label: function (tooltipItem, data) {
                  var label = data.datasets[tooltipItem.datasetIndex].label || '';
                  if (label) label += ': ';
                  label += tooltipItem.yLabel + ' ' + UM;
                  return label;
                }
            }
        },
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            filter: function(item) {
              if(hideModel)
                return !item.text.includes('Model');
              else
                return item;
            },
            fontColor: '#333',
            useLineStyle: true,
            // usePointStyle: true,
            // pointStyle: 'line' ,
            // boxHeight: 10, // NOT IMPLEMENTED
            // boxWidth: 10,
            // lineWidth: 1,
            // usePointStyle: false,
            // pointStyle: 'border:1px red solid'
          }
        }
      }
    });
  }



}



// WEBPACK FOOTER //
// ./src/pages/modal/modal.ts